import { render, staticRenderFns } from "./StyleSearch.vue?vue&type=template&id=8578cbc2&scoped=true"
import script from "./StyleSearch.vue?vue&type=script&lang=js"
export * from "./StyleSearch.vue?vue&type=script&lang=js"
import style0 from "./StyleSearch.vue?vue&type=style&index=0&id=8578cbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8578cbc2",
  null
  
)

export default component.exports